import React from 'react';
import { Provider } from 'react-redux';
import routes from '../routes';
import { syncHistoryWithStore } from 'react-router-redux';
import configureStore from '../store/configureStore';
import { hashHistory } from 'react-router';

const store = configureStore();
const history = syncHistoryWithStore( hashHistory, store );

export default class Root extends React.Component {
	render() {
		return (
			<Provider store={store}>
				{ routes(history) }
			</Provider>
		);
	};
}



// WEBPACK FOOTER //
// ./src/Containers/Root.js